import { ModuleWithProviders, NgModule } from '@angular/core';

// module
import { AuthGuard } from '@shared/auth/auth.guard';
import { RoleGuard } from '@shared/auth/role.guard';
import { AuthService } from '@shared/auth/auth.service';
import { AuthServerService } from '@shared/auth/auth-server.service';
import { AuthServerGuard } from '@shared/auth/auth-server.guard';
import { RoleServerGuard } from '@shared/auth/role-server.guard';
import { UserGuard } from './user.guard';
import { UserServerGuard } from './user-server.guard';

export * from '@shared/auth/auth.guard';
export * from '@shared/auth/auth.service';


@NgModule()
export class AuthModule {

  static forRoot(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        {
          provide: 'AuthGuard',
          useClass: AuthGuard
        },
        {
          provide: 'RoleGuard',
          useClass: RoleGuard
        },
        {
          provide: 'UserGuard',
          useClass: UserGuard
        }
      ]
    };
  }

  static forServer(): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        {
          provide: AuthService,
          useClass: AuthServerService
        },
        {
          provide: 'AuthGuard',
          useClass: AuthServerGuard
        },
        {
          provide: 'RoleGuard',
          useClass: RoleServerGuard
        },
        {
          provide: 'UserGuard',
          useClass: UserServerGuard
        }
      ]
    };
  }
}
